module.exports = {
  /**
   * @type {string} zh | en
   * @description 项目默认语言，定义后不可修改，不提供用户切换功能
   */
  language: 'zh'
}
